import dayjs from 'dayjs';
import { DateSeparatorProps } from 'stream-chat-react'
import { View, Text } from '@/components'

function formatChatDate(dateString) {
  const messageDate = dayjs(dateString)
  const today = dayjs()
  const yesterday = dayjs().subtract(1, 'day')

  if (messageDate.isSame(today, 'day')) {
    return "Today"
  } else if (messageDate.isSame(yesterday, 'day')) {
    return "Yesterday"
  } else {
    return messageDate.format('DD/MM/YYYY')
  }
}

export const DateSeparator = (props: DateSeparatorProps) => {
  const { date } = props

  return <View style={['fullWidth', 'center', 'py:2']}>
    <View style={['center', 'br:infinite', 'px:1', 'py:0.8', 'bg:neutralSolid300']}>
      <Text style={['c2', { color: 'rgba(50, 57, 64, 1)' }]} text={formatChatDate(date)} />
    </View>
  </View>
}